import styled, { css } from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledCameraButtonContainerProps {
  $isModal: boolean;
}
export const StyledCameraButtonContainer = styled.div<StyledCameraButtonContainerProps>`
  ${({ $isModal }) => $isModal && 'width: 100%'};
  margin: ${({ $isModal }) => $isModal ? 0 : '20px'};
`;

export const StyledCameraButtonFramed = styled.div`
  width: 100%;
  border-radius: 0;
`;

export const StyledCameraButtonFramedContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: white;
  background-color: black;
  padding: 5rem 2.75rem;
  border-radius: 0;
`;

export const StyledCameraButtonTitle = styled.h1`
  color: white;
`;

export const StyledCameraButtonButtonImgContainer = styled.button`
  cursor: pointer;
  overflow: visible;
`;

export const StyledCameraButtonButtonImg = styled.img`
  min-width: 12.5rem;
  max-height: 12.5rem;
  margin: 1.25rem 0;
`;

export const StyledCameraButtonSectionButton = styled.div`
  margin-top: 10px;
  width: 100%;
`;

export const StyledCameraButtonButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  word-break: break-all;
  background-color: ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  color: white;
  padding: 0.75rem;
  width: 100%;
  border: 2px solid ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  border-radius: ${({ theme }) => pxToRem(theme.button_radius || 0)};
  box-shadow: none;
  transition: 0.2s cubic-bezier(0.25, 0.1, 0.25, 0.1);
  cursor: pointer;
    
  &:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  }

  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    pointer-events: none;
    font-weight: 700;
    ${({ theme }) => theme.button_font && css`font-family: ${theme.button_font};`};
  }
`;
